import { useModuleProjectContext } from 'common/contexts/useModuleProjectContext';
import { sanatizeNavigationUrl } from 'common/hooks/route';
import { Link, LinkProps, useParams } from 'react-router-dom';

export function AppLink(props: Readonly<LinkProps>) {
  const { projectId } = useParams();
  const { activeProject } = useModuleProjectContext();

  const url = sanatizeNavigationUrl({
    url: props.to as string,
    urlProjectId: projectId ?? '',
    activeProjectId: activeProject?.moduleProjectID ?? '',
  });

  return <Link to={url}>{props.children}</Link>;
}
